<script setup>
const props = defineProps({
  component: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    required: true,
  },
})
const { locale } = useI18n()
const el = ref(null)
const t = computed(() => el.value.t)
watch(
  () => props.options?.locale,
  (value) => {
    locale.value = value.value
  },
  { deep: true, immediate: true },
)

defineExpose({
  t,
})
</script>

<template>
  <component
    :is="component"
    ref="el"
  />
</template>
